import angular from 'angular';
import googleMapShapes from './googleMapShapes';
import './style.scss';

export default angular
  .module('components.googleMapShapes', [])
  .component('googleMapShapes', googleMapShapes).name;
